/** @jsxImportSource @emotion/react */

import { Skeleton } from "antd";
import { SubGameResponse } from "api/game/type";
import { LOGO_MAIN } from "assets/Common";
import Loading from "components/Common/Loading";
import { isBajiGold } from "contants/common";
import { LIST_CODE_GAME_ARCADE } from "contants/game";
import { headerMenu, HeaderMenuStyle } from "contants/headerMenu";
import { CategoryGameType, LIST_CATEGORY_GAME } from "contants/menu-game";
import { PATH } from "contants/path";
import { GameTypeEnum } from "enums/game";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { getAnnouncement } from "store/announcement/announcement.thunk";
import { selectIsAuthenticated, selectUsername } from "store/auth";
import { selectIsCreditAgentLine, selectLoadingFeature } from "store/feature";
import { updateGameProviderCode } from "store/game";
import { getGameList } from "store/game/game.thunk";
import { ModalType, setOpenModal } from "store/modal";
import { selectProfile, selectProfileLoading } from "store/user";
import { theme } from "styles/theme";

import ButtonTelegram from "./ButtonTelegram";
import DropdownGameProvider from "./DropdownGameProvider";
import HeaderAuth from "./HeaderAuth";
import HeaderUnAuth from "./HeaderUnAuth";
import { HeaderStyle } from "./index.style";
import LanguageSelect from "./LanguageSelect";

const isShow = (isAuthenticated: boolean, name: string) => {
  if (
    name.includes("Promos") ||
    name.includes("Download") ||
    name.includes("AFFRegister") ||
    name.includes("Affiliate") ||
    name.includes("UplineContact")
  )
    return true;

  if (isAuthenticated) return true;

  return false;
};

export const Header = () => {
  const menuRef = useRef<HTMLDivElement>(null);
  const { pathname = "" } = useLocation();
  const { t } = useTranslation(["header", "currency"]);

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const isAuthenticated = useAppSelector(selectIsAuthenticated);
  const isLoadingProfile = useAppSelector(selectProfileLoading);
  const profile = useAppSelector(selectProfile);
  const username = useAppSelector(selectUsername);
  // const toggleFeature = useAppSelector(selectDataFeature);
  const isCreditAgentLine = useAppSelector(selectIsCreditAgentLine);
  const isLoadingToggle = useAppSelector(selectLoadingFeature);
  const categoryGames = isCreditAgentLine
    ? LIST_CATEGORY_GAME.filter((item) => item.id !== GameTypeEnum.Lottery)
    : LIST_CATEGORY_GAME;

  const [visibleMenu, setVisibleMenu] = useState<string>("");
  const [backgroundColor, setBackgroundColor] = useState<
    "#0A080B" | "transparent"
  >("transparent");
  const [colorText, setColorText] = useState<string>(
    `${theme.colors.lightText}`
  );

  const handleChangeColor = () => {
    if (
      (!pathname.includes("user") &&
        !pathname.includes("terms-and-conditions")) ||
      pathname === "/"
    ) {
      setColorText(`${theme.colors.lightText}`);
    } else {
      setColorText(`${theme.colors.lightText}`);
    }
  };

  const handleScroll = () => {
    if (window.scrollY < 15) {
      setBackgroundColor("transparent");
      handleChangeColor();
      return;
    }
    setColorText(`${theme.colors.lightText}`);
    setBackgroundColor("#0A080B");
  };

  const handleActionMenu = (item: HeaderMenuStyle) => {
    if (
      item.link === PATH.Promotion ||
      item.link === PATH.User.Referral ||
      item.link === PATH.Download ||
      item.link === PATH.User.myVip ||
      item.link === PATH.affiliatePage
    ) {
      if (item.link === PATH.affiliatePage) {
        window.open(PATH.affiliatePage);
      } else {
        navigate(item.link);
      }
      return;
    }
    dispatch(setOpenModal(item.link as ModalType));
  };

  const handlOpenUplineContact = () => {
    if (isAuthenticated) {
      dispatch(setOpenModal("uplineContact" as ModalType));
    } else {
      dispatch(setOpenModal("signin" as ModalType));
    }
  };

  const getGameLobby = async (
    idGame: string,
    path: string,
    providerCode?: string
  ) => {
    const res = await dispatch(getGameList(idGame));

    const { data } = res.payload as SubGameResponse;
    const filterData = data.filter(
      (item) =>
        item.provider_code !== LIST_CODE_GAME_ARCADE.SPRIBE &&
        item.provider_code !== LIST_CODE_GAME_ARCADE.AVIATRIX
    );

    if (filterData.length > 0) {
      dispatch(
        updateGameProviderCode(
          providerCode ? providerCode : filterData[0].provider_code
        )
      );
      navigate(
        `${path}/${providerCode ? providerCode : filterData[0].provider_code}`
      );
    }
  };

  const handleRedirectSubGame = (
    idGame: string,
    path: string,
    providerCode?: string
  ) => {
    if (
      idGame.includes(GameTypeEnum.Slot) ||
      idGame.includes(GameTypeEnum.Fishing) ||
      idGame.includes(GameTypeEnum.BoardGame)
    ) {
      setVisibleMenu("");
      return getGameLobby(
        idGame,
        path,
        providerCode
          ? providerCode
          : idGame.includes(GameTypeEnum.Fishing)
          ? "SG"
          : providerCode
      );
    }

    navigate(path);
  };

  useEffect(() => {
    if (!username) return;
    dispatch(getAnnouncement({ page: 1, size: 100, type: 2 }));
  }, [username]);

  useEffect(() => {
    handleChangeColor();
    setBackgroundColor("transparent");
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [pathname]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event?.target as Node;
      if (!menuRef?.current?.contains(target)) {
        setVisibleMenu("");
      }
    };
    if (visibleMenu) {
      document.addEventListener("mouseover", handleClickOutside);
    } else {
      document.removeEventListener("mouseover", handleClickOutside);
    }
    return () => document.removeEventListener("mouseover", handleClickOutside);
  }, [visibleMenu]);

  return (
    <div ref={menuRef} css={HeaderStyle.index(backgroundColor)}>
      <div css={HeaderStyle.container}>
        <div css={HeaderStyle.wrapper}>
          <div css={HeaderStyle.heading} onClick={() => navigate(PATH.Home)}>
            {/* <Image alt="img" src={LOGO_MAIN} preview={false} /> */}
            <img src={LOGO_MAIN} alt="Logo" />
          </div>

          <div css={HeaderStyle.listCategory}>
            {categoryGames.map((item: CategoryGameType, index: number) => (
              <div key={item.id}>
                <div
                  css={HeaderStyle.categoryItem(item, pathname, colorText)}
                  onClick={() => {
                    if (item.id === "LT") return;
                    item.id === "CRUSH"
                      ? handleRedirectSubGame(
                          "SL",
                          item.path,
                          LIST_CODE_GAME_ARCADE.SPRIBE
                        )
                      : handleRedirectSubGame(item.id, item.path);
                  }}
                  onMouseEnter={(e) => {
                    if (item.id !== "H") {
                      setVisibleMenu(item.id);
                    } else {
                      setVisibleMenu("");
                    }
                  }}
                  className={visibleMenu && "item-category"}
                >
                  {t(item.name)}
                </div>
                {item.id !== "H" && (
                  <DropdownGameProvider
                    key={`component-cate-dropdown-${index}`}
                    idCategoryGame={item.id}
                    visible={visibleMenu === item.id}
                    handleRedirectSubGame={handleRedirectSubGame}
                  />
                )}
              </div>
            ))}
          </div>

          <div css={HeaderStyle.rows}>
            <div css={HeaderStyle.menuList}>
              {headerMenu
                .filter((item) => {
                  // loại bỏ uplineContact nếu không phải BajiGold
                  // if (!isBajiGold && item.id === "uplineContact") return false;

                  // ẩn promos khi là credit agent line
                  if (isCreditAgentLine && item.id === "promos") return false;

                  // loại bỏ promos nếu toggleFeature bật
                  // if (item.id === "promos" && toggleFeature) return false;

                  // loại bỏ nếu isShow false
                  if (!isShow(isAuthenticated, item.label)) return false;

                  return true;
                })
                .map((item: HeaderMenuStyle) =>
                  isLoadingToggle ? (
                    <div key={item.label} css={HeaderStyle.menuItem(colorText)}>
                      <Skeleton.Avatar
                        size={"small"}
                        style={{ margin: "0 auto" }}
                        className="loading"
                      />
                      <Skeleton.Button
                        size="small"
                        style={{ width: 70, marginTop: "5px" }}
                        className="loading"
                      />
                    </div>
                  ) : (
                    <div
                      key={item.label}
                      css={HeaderStyle.menuItem(colorText)}
                      onClick={() => {
                        if (item.id === "uplineContact") {
                          handlOpenUplineContact();
                        } else {
                          handleActionMenu(item);
                        }
                      }}
                    >
                      <div css={HeaderStyle.menuItemIcon}>
                        <item.icon />
                      </div>
                      <span className={visibleMenu && "item-category"}>
                        {t(item.label)}
                      </span>
                    </div>
                  )
                )}
            </div>
            {!isBajiGold && <ButtonTelegram />}

            {!isLoadingProfile ? (
              profile && isAuthenticated ? (
                <HeaderAuth visibleMenu={visibleMenu} colorText={colorText} />
              ) : (
                <HeaderUnAuth />
              )
            ) : (
              <Loading height={40} center width={140} fontSize={24} />
            )}
            <LanguageSelect />
          </div>
        </div>
      </div>
    </div>
  );
};
